import { render, staticRenderFns } from "./reviewDetails.vue?vue&type=template&id=6fe689a8&scoped=true"
import script from "./reviewDetails.vue?vue&type=script&lang=js"
export * from "./reviewDetails.vue?vue&type=script&lang=js"
import style0 from "./reviewDetails.vue?vue&type=style&index=0&id=6fe689a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe689a8",
  null
  
)

export default component.exports